import React from 'react';
import { Button } from "../../../shadcn/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../../shadcn/components/ui/dialog";
import {useTranslation} from "../../../context/Internationalization"


const ImpersonateConfirmationModal = ({open, onClose, onImpersonate}) => {
  const {t} = useTranslation()

  return (
      <Dialog open={Boolean(open)} onOpenChange={(next, details) => !next && onClose?.(details?.event)}>
        <DialogContent closeLabel={t('close')}>
          <DialogHeader>
            <DialogTitle>Impersonate</DialogTitle>
            <DialogDescription>{t('impersonate_user')}</DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>{t('close')}</Button>
            <Button type="button" onClick={onImpersonate}>
              {t('ok')}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default ImpersonateConfirmationModal;
